import React from "react";
import "./Footer.css";
import logo from "../img/bwp zoo logo web page.png";

export default function Footer() {

  return (
    <footer >
      <div className='triangle-style'></div>
      <div className="footer-container">
        <div className="col1">
          <img src={logo} alt="BAHAWALPUR ZOO" />
          <div className="contact">
            <p><span>Location</span> : Stadium Road, Old City Bahawalpur, Punjab</p>
            <p><span>Phone</span> : (062) 9255334</p>
            <p><span>Email</span> : info@bahawalpurzoo.com</p>
            <p><span>Opening</span> hours : 9:00 AM - 5:00 PM</p>
          </div>
        </div>
        <div className="col2">
          <h2>Menu & Links</h2>
          <div className="links" id="contact">
            <a href="#home">Home</a>
            <a href="#planeYourVisit">Visit Plan</a>
            <a href="#gallery">Gallery</a>
            <a href="#library">Explore</a>
            <a href="#contact">Contact us</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
